module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: _vm.isMobile() ? 'modal--small' : 'modal--medium',
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "cursor": "pointer"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo",
    staticStyle: {
      "margin-bottom": "10px",
      "cursor": "pointer"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.title) + " " + _vm._s(_vm.subTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.locale.t('label_copy_training_desc')))]), _vm._v(" "), _c('div', {
    staticClass: "parent-calendar",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('div', [_c('custom-calendar', {
    attrs: {
      "show": _vm.isVisibleCalendar
    },
    on: {
      "update:selectedList": function($event) {
        return _vm.setNewList($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_selected_dates')) + ": " + _vm._s(_vm.selectedDates.length))]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "margin-right": "36px"
    }
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "new-button",
    staticStyle: {
      "margin-top": "15px"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_save')))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57b153e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/CopyTrainingOfTheDayForDatesModal.vue
// module id = 767
// module chunks = 0